import { SVGProps } from 'react';

const SvgWashingMachine = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M2 4a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V4Zm3-1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H5Z"
      clipRule="evenodd"
    />
    <circle cx={17} cy={6} r={1} fill="#081930" />
    <circle cx={12} cy={14} r={4} fill="#081930" />
  </svg>
);

export default SvgWashingMachine;
